/* unplugin-vue-components disabled */import { render } from "./verify.vue?vue&type=template&id=9a244a8c"
import script from "./verify.vue?vue&type=script&lang=js"
export * from "./verify.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__